import React from "react";
import CityWrapper from ".././Features/City";
import Header from ".././Layout/Header";
//import Footer from ".././Layout/Footer";

//TODO Header and footer will be broke into layouts

const City = props => (
  <div>
    <Header />
    <CityWrapper />
    {/*<Footer />*/}
  </div>
);
export default City;



// WEBPACK FOOTER //
// ./src/Views/City.js